export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-22.54e99598.png";